export default {
  title: 'Ma liste de courses',
  description: 'Renseignez ici tous les produits dont vous avez besoin, on s’occupe du reste.',
  placeholder: 'Ananas\nBrioche\nConfiture\nLiquide vaisselle ...',
  button: 'Voir les produits',
  info: {
    title: 'Ma liste de course',
    message:
      '“Ma liste de course” vous permet de faire toutes vos courses en <b>une seule recherche.</b><br><br>Pour chaque produit, on vous propose les meilleurs résultats, vous n’avez qu’à ajouter ce que vous voulez.<br><br><b>Vous avez oublié quelque chose ?</b> Pas de problème vous pouvez rajouter un produit à votre liste à tout moment depuis la barre en bas de votre écran.',
  },
  error: {
    'no-results': 'Aucun résultat trouvé pour cette liste de courses',
    'generic': ' Impossible d’envoyer la liste. Réessayez. ',
  },
};
